import { useSelector } from 'react-redux';

const selectIStockServer = (state) => state.widgetConfig.istockServer;
export const useIStockServer = () => useSelector(selectIStockServer);
